import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const ReadingBlockEditor = ({ block, onUpdate }) => {
    const readingText = block.readingText || '';
    const questions = block.questions || [];

    const addQuestion = () => {
        onUpdate({
            questions: [...questions, {
                questionText: '',
                options: ['', '', '', ''],
                correctAnswer: '',
                explanation: '',
                points: 1
            }]
        });
    };

    const removeQuestion = (index) => {
        onUpdate({
            questions: questions.filter((_, i) => i !== index)
        });
    };

    const updateQuestion = (index, field, value) => {
        onUpdate({
            questions: questions.map((q, i) => 
                i === index ? { ...q, [field]: value } : q
            )
        });
    };

    const updateOption = (questionIndex, optionIndex, value) => {
        const question = questions[questionIndex];
        const newOptions = [...question.options];
        newOptions[optionIndex] = value;
        updateQuestion(questionIndex, 'options', newOptions);
    };

    const addOption = (questionIndex) => {
        const question = questions[questionIndex];
        updateQuestion(questionIndex, 'options', [...question.options, '']);
    };

    const removeOption = (questionIndex, optionIndex) => {
        const question = questions[questionIndex];
        if (question.options.length <= 2) {
            alert('Должно быть минимум 2 варианта ответа');
            return;
        }
        const newOptions = question.options.filter((_, i) => i !== optionIndex);
        updateQuestion(questionIndex, 'options', newOptions);
    };

    return (
        <div style={{ display: 'grid', gap: '20px' }}>
            {/* Текст для чтения */}
            <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Текст для чтения</label>
                <p style={{ fontSize: '12px', color: '#999', marginBottom: '8px' }}>
                    Введите текст на английском, который студент должен прочитать перед ответами на вопросы
                </p>
                <textarea
                    value={readingText}
                    onChange={(e) => onUpdate({ readingText: e.target.value })}
                    rows={12}
                    placeholder="London is the capital city of England and the United Kingdom. It is located on the River Thames and has been a major settlement for two millennia..."
                    style={{ 
                        width: '100%', 
                        padding: '12px', 
                        border: '1px solid #ddd', 
                        borderRadius: '6px',
                        fontFamily: 'Georgia, serif',
                        fontSize: '14px',
                        lineHeight: '1.6'
                    }}
                />
                {readingText && (
                    <div style={{ 
                        marginTop: '10px', 
                        padding: '10px', 
                        background: '#f0f8ff', 
                        borderRadius: '6px',
                        fontSize: '12px',
                        color: '#666'
                    }}>
                        Символов: {readingText.length} | Слов: ~{readingText.trim().split(/\s+/).length}
                    </div>
                )}
            </div>

            {/* Вопросы с вариантами ответов */}
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h4 style={{ margin: 0 }}>Вопросы ({questions.length})</h4>
                    <button
                        type="button"
                        onClick={addQuestion}
                        style={{
                            padding: '8px 16px',
                            background: '#52c41a',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontWeight: '500'
                        }}
                    >
                        <FiPlus /> Добавить вопрос
                    </button>
                </div>

                {questions.length === 0 && (
                    <div style={{
                        padding: '40px',
                        textAlign: 'center',
                        background: '#f9f9f9',
                        borderRadius: '8px',
                        color: '#999'
                    }}>
                        Нет вопросов. Добавьте вопросы по тексту
                    </div>
                )}

                {questions.map((question, qIndex) => (
                    <div
                        key={qIndex}
                        style={{
                            padding: '15px',
                            background: '#f9f9f9',
                            borderRadius: '8px',
                            marginBottom: '10px',
                            border: '1px solid #e0e0e0'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                            <span style={{ fontWeight: '600' }}>Вопрос {qIndex + 1}</span>
                            <button
                                type="button"
                                onClick={() => removeQuestion(qIndex)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#ff4d4f',
                                    cursor: 'pointer'
                                }}
                            >
                                <FiTrash2 />
                            </button>
                        </div>

                        <div style={{ marginBottom: '12px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                                Текст вопроса
                            </label>
                            <input
                                type="text"
                                value={question.questionText}
                                onChange={(e) => updateQuestion(qIndex, 'questionText', e.target.value)}
                                placeholder="Например: What is the capital of England?"
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                            />
                        </div>

                        <div style={{ marginBottom: '12px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                                Варианты ответов (можно отметить несколько правильных)
                            </label>
                            {question.options.map((option, optIndex) => {
                                const selectedCorrect = Array.isArray(question.correctAnswer)
                                    ? question.correctAnswer
                                    : (question.correctAnswer ? [question.correctAnswer] : []);
                                const isChecked = selectedCorrect.includes(option);
                                return (
                                <div key={optIndex} style={{ display: 'flex', gap: '8px', marginBottom: '6px', alignItems: 'center' }}>
                                    <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={() => {
                                            let next = Array.isArray(question.correctAnswer)
                                                ? [...question.correctAnswer]
                                                : (question.correctAnswer ? [question.correctAnswer] : []);
                                            if (isChecked) {
                                                next = next.filter((v) => v !== option);
                                            } else {
                                                next.push(option);
                                            }
                                            const value = next.length <= 1 ? (next[0] || '') : next;
                                            updateQuestion(qIndex, 'correctAnswer', value);
                                        }}
                                        title="Отметьте правильный ответ"
                                    />
                                    <input
                                        type="text"
                                        value={option}
                                        onChange={(e) => updateOption(qIndex, optIndex, e.target.value)}
                                        placeholder={`Вариант ${optIndex + 1}`}
                                        style={{ flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                                    />
                                    {question.options.length > 2 && (
                                        <button
                                            type="button"
                                            onClick={() => removeOption(qIndex, optIndex)}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                color: '#ff4d4f',
                                                cursor: 'pointer',
                                                padding: '4px'
                                            }}
                                            title="Удалить вариант"
                                        >
                                            <FiTrash2 size={14} />
                                        </button>
                                    )}
                                </div>
                                );
                            })}
                            <button
                                type="button"
                                onClick={() => addOption(qIndex)}
                                style={{
                                    padding: '6px 12px',
                                    background: '#e6f7ff',
                                    color: '#1890ff',
                                    border: '1px solid #91d5ff',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    marginTop: '4px'
                                }}
                            >
                                + Добавить вариант
                            </button>
                        </div>

                        <div style={{ marginBottom: '12px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                                Объяснение (необязательно)
                            </label>
                            <textarea
                                value={question.explanation}
                                onChange={(e) => updateQuestion(qIndex, 'explanation', e.target.value)}
                                rows={2}
                                placeholder="Объяснение правильного ответа"
                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                            />
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '12px', fontWeight: '600' }}>
                                Баллы за вопрос
                            </label>
                            <input
                                type="number"
                                value={question.points || 1}
                                onChange={(e) => updateQuestion(qIndex, 'points', parseInt(e.target.value) || 1)}
                                min="1"
                                style={{ width: '100px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReadingBlockEditor;
